export const routes = {
  user_module_moduleBridgeFolder_home: {
    path: 'folder/:moduleBridgeHex/',
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
};
